import React, {useRef, useState} from 'react';
import {UsePermissions} from "../../../../hooks/usePermissions";
import {UseLoader} from "../../../../hooks/useLoader";
import {traerFacturasPagadas} from "../../../../api/liquidacion.service";
import {Toast} from "primereact/toast";
import {ContainerGroupForm} from "../../../../components/Containers/ContainerGroupForm";

import {Calendar} from "primereact/calendar";

import {Navigate} from "react-router";
import {TableDevolucionPagos} from "./TableDevolucionPagos";

export const DevolucionPagos = () => {
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const initParams = {
        fecha: new Date(),
    };
    const [field, setField] = useState(initParams);
    const [liquidaciones, setLiquidaciones] = useState([]);

    const buscar = async () => {

        try {
            for (let f in field) {
                if (field[f] === '') {
                    if (f === 'anio') f = 'Año';
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: `El campo ${f} es obligatorio`,
                        life: 3000
                    });
                    return;
                }
            }
            handleLoad(true);
            const response = await traerFacturasPagadas(field);
            handleLoad(false);

            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                setLiquidaciones([]);
                return;
            }
            setLiquidaciones(response.data)
        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    const buscarInfoFactura=async (e) => {
        e.preventDefault();

        await buscar()
    }

    const buscarInfoFacturaParen=async () => {
        await buscar()
    }
    return (
        <>
            <Toast ref={toast}/>
            <div className=" flex flex-wrap items-center  p-4 primary-color">
                <div className=" mt-2 relative lg:w-8/12 px-4">
                    <form onSubmit={buscarInfoFactura}>
                        <div className="row">
                            <ContainerGroupForm width="lg:w-4/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="anio"
                                >
                                    Fecha de pago desde: *
                                </label>
                                <Calendar id="fechacrea"
                                          value={field.fecha}
                                          locale="es"
                                          monthNavigator={true}
                                          yearNavigator={true}
                                          yearRange='2010:2030'
                                          dateFormat="yy-mm-dd"
                                          style={{width: "100%"}}
                                          onChange={(e) => setField({...field, fecha: e.value})} showIcon/>

                            </ContainerGroupForm>



                            <ContainerGroupForm width="lg:w-3/12">
                                <div className="mt-6 relative w-full px-4">
                                    <button
                                        className="warning-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Buscar
                                    </button>
                                </div>

                            </ContainerGroupForm>
                        </div>
                    </form>
                </div>

            </div>
            {permisos.consultar ? <TableDevolucionPagos reload={buscarInfoFacturaParen} pagados={liquidaciones} />: <Navigate to="/home"/> }
        </>
    );
};


